<template>
  <div :class="$style['text-highlight']">
    <div v-html="highlightText()" />
  </div>
</template>

<script setup>

const props = defineProps({
  text: {
    type: String,
    default: ''
  },
  inputString: {
    type: String,
    default: ''
  }
})

const capitalize = word => {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

const highlightText = () => {
  const { inputString, text } = props
  const subStrings = text.toLocaleLowerCase().split(inputString)
  const highlightedText = `${capitalize(subStrings[0]) || ''}<b><i>${subStrings[0] ? inputString : capitalize(inputString)}</i></b>${subStrings[1] || ''}`
  if (text.toLocaleLowerCase().includes(inputString)) {
    return highlightedText
  }
  return text
}

</script>
<style lang="scss" module>
.text-highlight {
  display: flex;
  width: 100%;
  height: 100%;
  font-size: $font-size-s + 0.1rem;
}
</style>
